import { fmtBRL, fmtInt } from "@/lib/api";
import { CheckCircle, Printer, PaperPlaneTilt } from "@phosphor-icons/react";
import HistoryPanel from "@/components/orders/HistoryPanel";

export default function OrderSummarySidebar({ order, totalCups, canAdmin, saving, onSave, onSend }) {
  return (
    <div className="lg:sticky lg:top-4 space-y-4">
      <div className="border border-black p-6 bg-black text-white" data-testid="summary-panel">
        <div className="overline text-white/60 mb-3">RESUMO</div>
        <div className="space-y-3">
          <div className="flex justify-between items-baseline text-sm">
            <span className="text-white/70">Total copos</span>
            <span className="font-mono font-bold text-3xl text-[#FFC000]">{fmtInt(totalCups)}</span>
          </div>
          <div className="text-sm border-t border-white/20 pt-3">
            <div className="text-white/70 mb-1">Cores de silk usadas</div>
            {(() => {
              const silks = [...new Set((order.order_items || []).map((it) => it.silk_color).filter(Boolean))];
              if (silks.length === 0) return <span className="text-[#FFC000] font-bold text-xs">— Definir por item —</span>;
              return (
                <div className="flex gap-1 flex-wrap">
                  {silks.map((s) => (
                    <span key={s} className="font-mono text-xs bg-white/10 px-2 py-1">{s}</span>
                  ))}
                </div>
              );
            })()}
          </div>
          {canAdmin && (
            <div className="flex justify-between text-sm border-t border-white/20 pt-3"><span className="text-white/70">Líquido</span><span className="font-mono font-bold text-[#00FF7F]">{fmtBRL(order.net_value)}</span></div>
          )}
        </div>
      </div>

      <button onClick={() => onSave(false, false)} disabled={saving} className="btn btn-ghost w-full" data-testid="save-button">
        <CheckCircle size={18} weight="bold" /> Salvar Alterações
      </button>
      <button onClick={() => onSave(false, true)} disabled={saving} className="btn btn-klein w-full" data-testid="reprint-button">
        <Printer size={18} weight="bold" /> Imprimir Pedido
      </button>
      {order.production_status === "em_desenvolvimento" && (
        <button onClick={onSend} disabled={saving} className="btn w-full py-6" data-testid="send-to-production">
          <PaperPlaneTilt size={18} weight="bold" /> Enviar para Produção
        </button>
      )}

      {/* Visual history with diffs */}
      <HistoryPanel history={order.history || []} />
    </div>
  );
}
